import { createSelector } from 'reselect'
import { featureStateSelector } from './featureStateSelector'

export const errorListOverviewReportSelector = createSelector(featureStateSelector, state => state.UIState.list.error)

export default errorListOverviewReportSelector
